var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.09 23.147c.558.678.558 1.356 0 2.034-.678.558-1.355.558-2.033 0l-7.058-7.117-7.117 7.117c-.678.558-1.356.558-2.034 0-.558-.678-.558-1.356 0-2.034l7.118-7.117-7.118-7.177c-.558-.678-.558-1.356 0-2.034.678-.558 1.356-.558 2.034 0l7.117 7.177 7.117-7.117c.678-.558 1.356-.558 2.034 0 .558.678.558 1.356 0 2.034l-7.117 7.117 7.057 7.117Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.cb80b006ee29e13ed58a49625b71bdfc.svg";